export default "__VITE_ASSET__BmlrzbPo__"